var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2499 6.75H5.91664C5.54999 6.75 5.25 7.05 5.25 7.41667C5.25 13.6767 10.3232 18.75 16.5829 18.75C16.9496 18.75 17.2496 18.45 17.2496 18.0833V15.7567C17.2496 15.39 16.9496 15.09 16.5829 15.09C15.7563 15.09 14.9497 14.9567 14.203 14.71C14.1364 14.6833 14.063 14.6767 13.9964 14.6767C13.823 14.6767 13.6564 14.7433 13.5231 14.87L12.0564 16.3367C10.1698 15.37 8.62322 13.83 7.66325 11.9433L9.12987 10.4767C9.31653 10.29 9.36986 10.03 9.29653 9.79667C9.04987 9.05 8.91654 8.25 8.91654 7.41667C8.91654 7.05 8.61655 6.75 8.2499 6.75Z",
    fill: "#ADBFDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.611 11.4167C16.611 9.19145 14.8072 7.38755 12.582 7.38755V6.11255C15.5114 6.11255 17.886 8.48733 17.886 11.4167H16.611Z",
    fill: "#ADBFDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9445 11.4168C13.9445 10.6643 13.3345 10.0543 12.582 10.0543V8.7793C14.0387 8.7793 15.2195 9.96017 15.2195 11.4168H13.9445Z",
    fill: "#ADBFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallBackButton);
export default __webpack_public_path__ + "static/media/callBackButton.a72f237d6107d516baee4ab537a833ca.svg";
export { ForwardRef as ReactComponent };